import { useContext } from 'react';
import AuthContext from '../contexts/FirebaseContext';
import DevRoleContext from '../contexts/DevRoleContext';

const useAuth = () => {
  const auth = useContext(AuthContext);
  const { isEmulatingRoles: isEmulating, isClearingSucursales, getEffectiveRole } = useContext(DevRoleContext);

  // console.log({ realSucu: auth?.user?.sucu });
  // In production or when not emulating anything, return auth as-is
  if ((!isEmulating && !isClearingSucursales) || !auth.user) {
    return auth;
  }

  // Return auth with emulated role/sucursales
  return {
    ...auth,
    user: {
      ...auth.user,
      ...(isEmulating && { role: getEffectiveRole(), realRole: auth.user.role }),
      ...(isClearingSucursales && { sucu: [''], realSucu: auth.user.sucu }),
    },
  };
};

export default useAuth;
